import { CircleAlert, Loader, Pause, Play } from "lucide-react";
import type { PlaybackStatus } from "@/lib/application/ports";
import { cn } from "@/lib/utils";

type AudioButtonIconProps = {
	audioStatus: PlaybackStatus;
	className?: string;
};

export const AudioButtonIcon = ({
	audioStatus,
	className,
}: AudioButtonIconProps) => {
	if (audioStatus === "PLAYING") {
		return (
			<>
				<Pause
					fill="#000"
					strokeWidth={2}
					className={cn("text-white", className)}
				/>
				<span className="sr-only">Pause</span>
			</>
		);
	}

	if (audioStatus === "ERROR") {
		return (
			<>
				<CircleAlert strokeWidth={2} className={cn("text-white", className)} />
				<span className="sr-only">Error</span>
			</>
		);
	}

	if (audioStatus === "LOADING") {
		return (
			<>
				<div className="animate-spin">
					<Loader
						fill="#000"
						strokeWidth={2}
						className={cn("text-white", className)}
					/>
				</div>
				<span className="sr-only">Loading</span>
			</>
		);
	}

	return (
		<>
			<Play
				fill="#000"
				strokeWidth={2}
				className={cn("text-white", className)}
			/>
			<span className="sr-only">Play</span>
		</>
	);
};
